import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { auth } from "../../firebase";
import { signInWithCustomToken } from "firebase/auth";
import LoadingSpinner from "components/LoadingSpinner";

export default function SamlCallback() {
  const history = useHistory();
  const [status, setStatus] = useState("Processing SSO callback...");
  const [error, setError] = useState("");

  useEffect(() => {
    async function handleCallback() {
      try {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token") || params.get("customToken");
        const errParam = params.get("error");
        let redirect = params.get("redirect") || "";

        // If IdP or server redirected with an error, forward user to sign-in page with message.
        if (errParam) {
          const msg = decodeURIComponent(errParam);
          const target = `/authentication/sign-in?error=${encodeURIComponent(msg)}&redirect=${encodeURIComponent(redirect || '/')}`;
          // Replace location so back doesn't keep the error callback
          return window.location.replace(target);
        }

        if (!token) throw new Error("Missing token in callback URL.");
        setStatus("Signing in...");
        await signInWithCustomToken(auth, token);
        setStatus("Sign-in successful — redirecting...");

        // If no explicit redirect provided, choose landing by user role:
        // tenant_admin → tenant users admin page, ordinary user → settings/profile page.
        if (!redirect || redirect === "/") {
          try {
            const idTokenResult = await auth.currentUser.getIdTokenResult();
            const role = idTokenResult?.claims?.role || "";
            if (role === "tenant_admin") redirect = "/tenant-users";
            else redirect = "/settings";
          } catch (e) {
            // fallback to root on any error
            redirect = "/";
          }
        }

        // small delay so user can see message
        setTimeout(() => {
          window.location.replace(redirect);
        }, 300);
      } catch (e) {
        console.error("SAML callback error:", e);
        // On failure, redirect back to sign-in with an error query so the app shows a friendly message
        const safeMsg = encodeURIComponent(e?.message || 'SSO sign-in failed');
        return window.location.replace(`/authentication/sign-in?error=${safeMsg}`);
      }
    }
    handleCallback();
  }, []);

  const showingSpinner = !error && (status && status.toLowerCase().includes("sign"));

  return (
    <VuiBox p={3} maxWidth={700} mx="auto" display="flex" flexDirection="column" alignItems="stretch">
      <VuiTypography variant="h4" fontWeight="bold" mb={2}>SSO Callback</VuiTypography>
      {showingSpinner ? (
        <LoadingSpinner label={status} centered size="lg" />
      ) : (
        <VuiTypography mb={2}>{status}</VuiTypography>
      )}

      {error && (
        <>
          <VuiTypography color="error" mb={2}>{error}</VuiTypography>
          <VuiButton color="info" onClick={() => history.push("/authentication/sign-in")}>Return to sign-in</VuiButton>
        </>
      )}
    </VuiBox>
  );
}
